export function hexToRGB(h) {
    const mask = 0xff;
    return [(h >> 16) & mask, (h >> 8) & mask, h & mask].map((x) => x / 255);
}
